import { AbsenceTypology } from 'helpers/Enums';

interface IProps {
    value?: AbsenceTypology
    otherTypology?: string
}

let AbsenceTypologyLabel = ({ value, otherTypology }: IProps) => {
    switch (value) {
        case AbsenceTypology.Other:
            return(<span>
                {otherTypology != null && otherTypology !== '' ? otherTypology : 'Altro'}
            </span>);

        case AbsenceTypology.NotAvailable:
            return(<span>Non Disponibile</span>);

        default:
            return(<span></span>);

    }
}

export default AbsenceTypologyLabel;